enum AssetFieldNames {
  Id = 'id',
  Color = 'color',
  Name = 'name',
  Prefix = 'prefix',
  RefreshQrPrefixForAssets = 'refreshQrPrefixForAssets',
}

export default AssetFieldNames;
